import {SignalSlashIcon} from "@heroicons/react/20/solid";
import {RiAreaChartLine, RiBarChartGroupedFill, RiLineChartLine, RiStackedChartLine} from "@remixicon/react";
import React from "react";

// type ChartType = 'none' | 'bar' | 'line' | 'area' | 'histogram' | 'scatter' | 'donut' | 'spark';
export type ChartType = "none" | "bar" | "line" | "area" | "histogram";

export interface ChartConfig {
  data: any[];
  index: string;
  categories: string[];
  title?: string;
  valueFormatter?: string;
  colors?: string[];
  xAxisLabel?: string;
  yAxisLabel?: string;
}

export interface ChartData {
  type: ChartType;
  config: ChartConfig;
}

interface ChartTypeOption {
    id: ChartType;
    name: string;
    icon: React.ComponentType<{ className?: string }>;
}

export const CHART_TYPE_OPTIONS: ChartTypeOption[] = [
    { id: "none", name: "No Chart", icon: SignalSlashIcon },
    { id: "bar", name: "Bar Chart", icon: RiBarChartGroupedFill },
    { id: "line", name: "Line Chart", icon: RiLineChartLine },
    { id: "area", name: "Area Chart", icon: RiAreaChartLine },
    { id: "histogram", name: "Histogram", icon: RiStackedChartLine },
    // { id: 'scatter', name: 'Scatter Plot', icon: RiBubbleChartFill },
    // { id: 'donut', name: 'Donut Chart', icon: RiDonutChartFill },
    // { id: 'spark', name: 'Spark Chart', icon: SparklesIcon }
];
